import React, { useState } from "react";
import { uploadMedia } from "../../services/AdminServices";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
function AdminGalleryUploadPage() {
  const [form, setForm] = useState({
    type: "photo",
    title: "",
    description: "",
    urlThumbnail: "",
    urlMedia: "",
    eventDate: "",
    category: "",
    locale: "en",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await uploadMedia(form);
    if (response?.status === "201") {
      alert("✅ Successfully saved to DB!");
      setForm({
        type: "photo",
        title: "",
        description: "",
        urlThumbnail: "",
        urlMedia: "",
        eventDate: "",
        category: "",
        locale: "en",
      });
    } else {
      alert("❌ Failed to save. Check console.");
      console.error(response);
    }
  };

  return (
    <React.Fragment>
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>

      {/* Title Section with Overlay */}
      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white"> Admin Gallery Upload</h1>
          </div>
        </div>
      </div>
      <div
        className="upload-page"
        style={{ maxWidth: 600, margin: "auto", padding: 20 }}
      >
        <form onSubmit={handleSubmit}>
          <label>Type</label>
          <select name="type" value={form.type} onChange={handleChange}>
            <option value="photo">Photo</option>
            <option value="video">Video</option>
          </select>

          <label>Title</label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
          />

          <label>Description</label>
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
          />

          <label>Thumbnail URL</label>
          <input
            type="text"
            name="urlThumbnail"
            value={form.urlThumbnail}
            onChange={handleChange}
            required
          />

          <label>{form.type === "photo" ? "Photo URL" : "Video URL"}</label>
          <input
            type="text"
            name="urlMedia"
            value={form.urlMedia}
            onChange={handleChange}
            required
          />

          <label>Event Date</label>
          <input
            type="date"
            name="eventDate"
            value={form.eventDate}
            onChange={handleChange}
          />

          <label>Category</label>
          <input
            type="text"
            name="category"
            value={form.category}
            onChange={handleChange}
            placeholder="Retreat, Worship, Praise"
          />

          <label>Locale</label>
          <select name="locale" value={form.locale} onChange={handleChange}>
            <option value="en">English</option>
            <option value="es">Spanish</option>
          </select>

          <button type="submit" style={{ marginTop: 20 }}>
            Submit
          </button>
        </form>
      </div>
      <FooterPanel />
    </React.Fragment>
  );
}

export default AdminGalleryUploadPage;
